import { DEFAULT_ERROR_MESSAGE } from '../data-types/initialisation/initialisationConstants';
import { AcceptedCountries } from '../data-types/international/internationalEnums';
import { MenuMainResponse } from '../data-types/main-menu/mainMenuInterfaces';
import { BACKEND_LOCALIZED_COUNTRIES } from '../data-types/sports/sportsConstants';
import { menuMainCommand } from '../socket-types/menuSocketTypes';
import { updateSportsMenu } from '../state/actions/navigationActions';
import { store } from '../state/store';
import { createTabsAndSubTabsMenu, sortSportsMenuByPriority } from '../utils/menu';
import { sendCommand } from './commandsHandler';

export const menuMain = async (userId?: number) => {
  const {
    userData: { userLocation },
    customization: {
      featureFlags: { bespokeSportsMenu },
    },
  } = store.getState();

  const res = await sendCommand<MenuMainResponse>(menuMainCommand, { userId, country: userLocation || AcceptedCountries.GREAT_BRITAIN });

  if (res.error && res.error.notification && res.error.notification.userFriendlyMessage) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.error) {
    throw new Error(DEFAULT_ERROR_MESSAGE);
  }

  let sportsbookMenu = res.data.fullMenu;
  const isLocalizedOnBackend = userLocation && BACKEND_LOCALIZED_COUNTRIES.includes(userLocation);
  const isBespoke = bespokeSportsMenu && res.data.isBespoke;

  if (!isLocalizedOnBackend && !isBespoke) {
    sportsbookMenu = sortSportsMenuByPriority(res.data.fullMenu);
  }

  const { tabs, subTabs, inPlaySubTabs } = createTabsAndSubTabsMenu(sportsbookMenu);

  updateSportsMenu({
    tabs,
    subTabs,
    inPlaySubTabs,
    menu: res,
  });
};
